/* @ngInject */
const myPhoneInfo = (
  valueHandler,
  labels,
  toaster,
  $$phone
) => {
  return {
    restrict: 'E',
    scope: {
      myPhones: '=',
      id: '@myId',
    },

    template: require('./myPhoneInfo.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.removePhone = async (_index) => {
        const id = $scope.myPhones[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$phone.request.delete(id)
            toaster.message(message)
            $scope.myPhones.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          toaster.message(labels.phone.success.delete)
          $scope.myPhones.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myPhoneInfo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/directives/myPhoneInfo.js